(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSAreaDeleteController',SSAreaDeleteController);

    SSAreaDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSArea'];

    function SSAreaDeleteController($uibModalInstance, entity, SSArea) {
        var vm = this;

        vm.sSArea = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSArea.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
